import React from "react";
import assign from "object-assign";
import Swipe from "react-swipe";

let timer,
    interval = 10000;

let SuspectCarousel = React.createClass({
    propTypes: {
        data: React.PropTypes.arrayOf(React.PropTypes.object).isRequired
    },
    getInitialState() {
        return {
            data: this.props.data.map((item, i) => assign(item, {id: i})),
            current: 0,
            last: 0,
            carouselIndex: 0
        };
    },
    carouselCallback(i) {
        this.setState({carouselIndex: i});
    },
    setSlide(id) {
        if (timer) { clearTimeout(timer); }
        this.setState({
            current: id,
            last: this.state.current
        });
        timer = setTimeout(this.next, interval);
    },
    next(){
        this.setSlide(this.state.current < this.state.data.length - 1 ? this.state.current + 1 : 0);
    },
    componentDidMount() {
        timer = setTimeout(this.next, interval);
    },
    componentWillUnmount() {
        if (timer) { clearTimeout(timer); }
    },
    render() {
        return (
            <div className={["eo-suspect-carousel", this.props.className, `current-${this.state.current}`].join(" ")}>
                <div className="eo-suspect-carousel-text-wrap">
                    {this.state.data.map(
                        slide => (
                            <div key={slide.id}
                                 className={["eo-suspect-carousel-text", "eo-info-panel-copy", (this.state.current === slide.id ? "in" : ""), (this.state.last === slide.id ? "in-2" : "")].join(" ")}>
                                <span className={`text-icon icon ${slide.icon}`}/>
                                <h3>{slide.title}</h3>
                                <p>{slide.text}</p>
                            </div>
                        )
                    )}
                </div>
                <div className="eo-suspect-carousel-item-wrap">
                    {this.state.data.map(
                        slide => (
                            <p onClick={this.setSlide.bind(null, slide.id)} key={slide.id} className={["eo-suspect-carousel-item", (this.state.current === slide.id ? "active" : "")].join(" ")}>
                                <span className="title">{slide.title}</span>
                            </p>
                        )
                    )}
                </div>
                <div className="eo-suspect-carousel-mobile">
                    <Swipe slideToIndex={this.state.carouselIndex} className="carousel" callback={this.carouselCallback}>
                        {this.state.data.map(
                            slide => (
                                <div key={slide.id} className="mobile-slide">
                                    <span className={`icon ${slide.icon}`}/>
                                    <h3>{slide.title}</h3>
                                    <p>{slide.text}</p>
                                </div>
                            )
                        )}
                    </Swipe>
                    <div className="carousel-dots">
                        {this.state.data.map((slide, i) => <span onClick={this.carouselCallback.bind(null, i)}key={slide.id} className={["carousel-dot", (i === this.state.carouselIndex ? "active" : "")].join(" ")}/>)}
                    </div>
                </div>
            </div>
        );
    }
});

export default SuspectCarousel;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/in-the-home/components/SuspectCarousel.js
 **/